const Helpers = {
	getCookie(name: string): string {  
		const match = document.cookie.match(new RegExp(name + '=([^;]+)'));
		if (match) return match[1];
		return '';
	},
	getFormattedPrice(p: number): string {
		const whole = Math.floor(p);
		const remainder = p - whole;
		const formatter = new Intl.NumberFormat('en-AU', {
			style: 'currency',
			currency: 'AUD',
			minimumFractionDigits: remainder ? 2 : 0
		});
		return formatter.format(p);
	},
	getColour(code: string): Array<any> {
		const colourMap: any = {
			'040': '#fff',
			'219': '#000',
			'3U5': 'red',
			'EA20': '#000'
		};
		return code ? colourMap[code] || '' : '';
	}
}
export default Helpers;
